import store from "@/store";
import {DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES} from "@/i18n";

const STORAGE_KEY = 'how2ai.language';

/* Thai is the dominant language for this service, so it is the default and English is only
   ever reached deliberately: an explicit ?lang= (which AIS or a campaign can pin) or the
   visitor's own last choice from the toggle. The browser language is not consulted - an
   English handset in Thailand should still land on the Thai page. */
export function resolveLanguage() {
    const requested = new URLSearchParams(window.location.search).get('lang');
    if (isSupported(requested)) return requested.toLowerCase();

    const stored = readStoredLanguage();
    if (isSupported(stored)) return stored.toLowerCase();

    return DEFAULT_LANGUAGE;
}

export function setLanguage(language) {
    if (!isSupported(language)) return;

    const normalised = language.toLowerCase();
    store.commit('setLanguage', normalised);
    document.documentElement.setAttribute('lang', normalised);
    writeStoredLanguage(normalised);
}

function isSupported(language) {
    return !!language && SUPPORTED_LANGUAGES.includes(language.toLowerCase());
}

function readStoredLanguage() {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
        return null;
    }
}

function writeStoredLanguage(language) {
    try {
        window.localStorage.setItem(STORAGE_KEY, language);
    } catch (error) {
        /* Private browsing - the URL parameter and the browser language still work. */
    }
}
